module.exports = __webpack_public_path__ + "img/cdu-vorsitz.ed8d506c.png";